import * as React from "react";
import { LinearProgress } from "@mui/material";


export const LoadingIndicator: React.FC<{}> = () => (
    <LinearProgress color="secondary" />
);
